module.exports = __webpack_public_path__ + "img/CPSC.f5533090.jpg";